<template>
  <v-menu bottom nudge-bottom="30" content-class="rounded-lg" :close-on-content-click="false">
    <template #activator="{ attrs, on }">
      <v-btn class="custom-button" icon dense color="primary" v-bind="attrs" v-on="on">
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
    </template>

    <v-sheet color="white" class="d-flex flex-column pa-4 rounded-lg gap-3">
      <span class="light-text">Medicamentos</span>
      <v-radio-group v-model="filter.medicine" dense hide-details class="gap-3">
        <v-radio label="Medicamentos sugeridos de acordo com a bula" value="bula" />
        <v-radio label="Todos os medicamentos" value="all" />
      </v-radio-group>
      <span class="light-text">Cobertura</span>
      <v-checkbox v-model="filter.coverage" label="Inclusos no SUS" dense hide-details value="public" />
      <v-checkbox v-model="filter.coverage" label="Inclusos na DUT/ROL" dense hide-details value="private" />
    </v-sheet>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      filter: {
        medicine: 'bula',
        coverage: [],
      },
    }
  },
  watch: {
    filter: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.light-text {
  color: #a9a8aa;
}
.v-input {
  margin: 0;
  padding: 0;
}
:deep(.v-radio) {
  margin: 0 !important;
}
:deep(.v-radio i),
:deep(.v-input--selection-controls__input i) {
  color: var(--v-neutral-lighten17);
}
:deep(.v-label) {
  color: var(--v-neutral-lighten17);
}
:deep(.v-input--radio-group__input) {
  gap: 12px;
}
.v-btn--icon {
  height: 24px !important;
  width: 24px !important;
}
</style>
